import { useMutation } from '@tanstack/react-query';

import type {
  SystemOwnerResponse,
  ToggleSystemOwnerLockParams,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useToggleSystemOwnerLockMutation = () =>
  useMutation({
    mutationFn: (params: ToggleSystemOwnerLockParams) =>
      HttpClient.request<SystemOwnerResponse>({
        method: 'PUT',
        url: `${params.url}/${params.id}/${params.action}`,
      }),
  });
